import React from 'react';
import styles from './lStarInstruction.module.scss';
import ismobilejs from 'ismobilejs';

const isMobileJs = ismobilejs();
// isMobileJs.tablet
const isMobile = isMobileJs.any;
class LStarInstruction extends React.Component {
  constructor(props) {
    super(props);
    this.state = {

    }
  }
  render() {
    return (
      <div className={styles.instructCon} style={{marginTop: isMobileJs.tablet ? '0' : '-150px'}}>
        <div className={styles.logoCon}>
          <img className={styles.logo} src={require('../../assets/img/instruction/img_medal-rules@2x.png')} />
          <p className={styles.tips}>累计100颗星星可兑换1个水晶球</p>
        </div>
        <div className={styles.sbuTips}>每个星星罐最多可以存储20个同颜色的水晶球，超过20个水晶星球后会自动点亮下一个星星罐</div>
        <div className={styles.detailCon}>
          <div className={styles.title}>如何获取星星？</div>
          <div className={styles.briefCon}>
            <div className={styles.briefItem}>
              <p className={styles.briefItemLarge}>• 互动题答题正确</p>
              <p className={styles.briefItemSmall}>积极回答老师在课中发送的答题卡，答对就有机会获取星星哟～</p>
            </div>
            <div className={styles.briefItem}>
              <p className={styles.briefItemLarge}>• 课堂积极表现</p>
              <p className={styles.briefItemSmall}>课中积极互动，就有机会被主讲/助教老师奖励小星星哟～</p>
            </div>
            {/* <div className={styles.briefItem}>
              <p className={styles.briefItemLarge}>• 积极到课</p>
              <p className={styles.briefItemSmall}>课中积极互动，就有机会被主讲/助教老师奖励小星星哟～</p>
            </div> */}
          </div>
        </div>
        {/* <p className={styles.endTips}>直播完课（观看直播时长超过课程时长80%）或者回放到课（未参加直播的宝宝，课程结束后20天内观看回放超过课程时长50%）均有机会获得星星哟～</p> */}
      </div>
    )
  }
}

export default LStarInstruction;
